import * as React from "react"
import tw, { styled } from "twin.macro"
import Shevron from "./Shevron"

const Container = styled.div`
  ${tw`bg-gray-50`}
`

const InnerContainer = styled.div`
  ${tw`max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8`}
`

const Content = styled.div`
  ${tw`max-w-3xl mx-auto`}
`

const Header = styled.h2`
  ${tw`text-center text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10`}
`

const ItemWrapper = styled.div`
  ${tw`mt-6 border-t border-gray-200 pt-6`}
`

const DefinitionItem = styled.dt`
  ${tw`text-lg leading-7`}
`

const Button = styled.button`
  ${tw`text-left w-full flex justify-between items-start text-gray-400 focus:outline-none focus:text-gray-900`}
`

const QuestionSpan = styled.span`
  ${tw`font-medium text-gray-900`}
`

const IconSpan = styled.span`
  ${tw`ml-6 h-7 flex items-center transform rotate-0`}
  ${props => props.itemOpen && tw`-rotate-180`}
`

const DefinitionContent = styled.dd`
  ${tw`mt-2 pr-12`}
`

const Description = styled.p`
  ${tw`text-base leading-6 text-gray-500`}
`

const items = [
  {
    question: "Czy organizujecie kursy grupowe?",
    answer:
      "Nasze kursy prowadzone są tylko w trybie indywidualnym.",
  },
  {
    question: "Co zawiera cena kursu?",
    answer:
      "Cena za kurs zawiera wszystkie opłaty związane z kursem, tj. wykłady, materiały, egzamin oraz zaświadczenie o ukończeniu kursu.",
  },
  {
    question: "Czy uczestnicy otrzymują certyfikat?",
    answer:
      "Tak, po ukończeniu kursu i zdaniu egzaminu uczestnicy otrzymują imienne zaświadczenie o ukończeniu kursu z podaną ilością godzin z poszczególnego zakresu materiału, ilością godzin praktyki oraz teorii.",
  },
  {
    question: "Jak wygląda egzamin z kursu księgowości?",
    answer:
      "Na ostatnich zajęciach przeprowadzany jest egzamin praktyczny polegający na księgowaniu operacji gospodarczych w nowo założonej firmie w programie „Symfonia” na których ćwiczymy podczas całego kursu.",
  },
  {
    question: "Jakie materiały otrzymują uczestnicy kursu księgowości?",
    answer:
      "Uczestnicy kursy księgowości, zarówno podstaw jak i samodzielny księgowy otrzymują autorskie materiały w formie drukowanej, skrypt ok. 60 stron zawierający teorię oraz płytę CD z wersjami demo programów używanych na kursie do zainstalowania w domu. Można robić kopię bazy danych z zajęć i ćwiczyć w domu. Na płycie CD znajdują się również, w formacie PDF, aktualne akty prawne dotyczące rachunkowości i podatków. Dodatkowo na każdych zajęciach uczestnicy otrzymują wydruki z ćwiczeniami wykonywanymi na zajęciach.",
  },
  {
    question:
      "Jaka jest proporcja pomiędzy zajęciami teoretycznymi a praktycznymi?",
    answer:
      "Pierwsze zajęcia to teoria, na drugich rozpoczynamy pracę z programem polegającą na założeniu nowej firmy i księgowaniu operacji gospodarczych w tej jednej firmie. Następnie część kolejnych zajęć to teoria dotycząca np. podatków, środków trwałych i od razu przechodzimy do praktyki, pod koniec kursu jest sama praktyka.",
  },
  {
    question: "Jak wyglądają płatności za kursy?",
    answer:
      "Do trzech dni od daty przesłania formularza zgłoszeniowego należy wpłacić kwotę 300zł tytułem zaliczki na podane w mailu potwierdzającym zgłoszenie konto bankowe. Pozostałą kwotę należy wpłacić przed datą rozpoczęcia kursu.",
  },
  {
    question: "Czy można płacić w ratach?",
    answer:
      "Zaliczkę należy wpłacić do trzech dni od daty zgłoszenia, ewentualna późniejsza wpłata pozostałej kwoty wymaga indywidualnych ustaleń",
  },
  {
    question: "Czy wystawiacie faktury?",
    answer:
      "Tak, jeżeli otrzymujemy zgłoszenie od firmy faktura wystawiana jest automatycznie, dla osób fizycznych wystawiamy faktury na życzenie.",
  },
  {
    question:
      "Nie miałem dotychczas kontaktu ani z księgowością ani z kadrami, płacami czy te kursy są dla mnie?",
    answer:
      "Tak, uczymy od samych podstaw, wyjątkiem jest kurs samodzielny księgowy który jest przeznaczony dla osób które ukończyły kurs podstawy księgowości lub księgowych chcących poszerzyć swoją wiedzę.",
  },
  {
    question: "Czy organizujecie kursy indywidualne?",
    answer:
      "Nasze kursy prowadzone są tylko w trybie indywidualnym.",
  },
]

const Faq = () => {
    const [currentIndex, setCurrentIndex] = React.useState(0)
  return (
    <Container>
      <InnerContainer>
        <Content>
          <Header>Najczęściej zadawane pytania</Header>
          {items.map((item, index) => (
            <ItemWrapper key={index}>
              <dl>
                <div>
                  <DefinitionItem>
                    <Button onClick={() => setCurrentIndex(index)}>
                      <QuestionSpan>{item.question}</QuestionSpan>
                      <IconSpan itemOpen={index === currentIndex}>
                        <Shevron />
                      </IconSpan>
                    </Button>
                  </DefinitionItem>
                  {index === currentIndex && <DefinitionContent>
                    <Description>{item.answer}</Description>
                  </DefinitionContent> }
                </div>
              </dl>
            </ItemWrapper>
          ))}
        </Content>
      </InnerContainer>
    </Container>
  )
}

export default Faq
